import { compose, not, prop, test, uniqWith } from 'ramda';

export const toMegabyte = (size) => size / 1000000;
export const fileName = prop('name');
export const checkOverallFileSize = (maxSizeOverall) => (files) => {
	if (!maxSizeOverall) return false;

	let overallFileSize = 0;
	for (const file of files) {
		overallFileSize = overallFileSize + file.size;
	}

	return overallFileSize > maxSizeOverall;
};
export const checkMaxFilesCount = (maxFilesCount) => (files) => files.length > maxFilesCount;
export const checkAcceptedFileTypes = (acceptedFileTypes) => compose(not, test(acceptedFileTypes), fileName);
export const checkFileSize = (maxSize) => (file) => (maxSize ? maxSize < file.size : false);
export const combineFiles = (newFiles, files) => uniqWith((a, b) => a.name === b.name, files.concat(newFiles));

const processNewFiles = (newFiles, currentFiles, options) => {
	const { acceptedFileTypes, maxSize, maxSizeOverall, maxFilesCount, maxFileNameSize } = options;
	const errors = [];

	// Check individual file size, Name length and type for every new file
	for (const file of newFiles) {
		if (file.name.length > maxFileNameSize) {
			errors.push({ type: 'maxFileNameSizeExtended', limit: maxFileNameSize });
		}

		if (checkAcceptedFileTypes(acceptedFileTypes)(file)) {
			errors.push({ type: 'acceptedFileTypeMessage', name: file.name });
		}

		if (checkFileSize(maxSize)(file)) {
			errors.push({ type: 'maxSizeMessage', name: file.name, limit: toMegabyte(maxSize) });
		}
	}

	const combinedFiles = combineFiles(newFiles, currentFiles);

	// Check max files count
	if (checkMaxFilesCount(maxFilesCount)(combinedFiles)) {
		errors.push({ type: 'maxFileCountExtended', limit: maxFilesCount });
	}

	// Check combined file size of all files
	if (checkOverallFileSize(maxSizeOverall)(combinedFiles)) {
		errors.push({ type: 'maxSizeOverallMessage', limit: toMegabyte(maxSizeOverall) });
	}

	return { combinedFiles, errors };
};

export default processNewFiles;
